module.exports = __webpack_public_path__ + "fonts/Open_Sans-600-vietnamese23.b05edf9.woff2";